import { ArrowRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import { useTranslation } from 'next-i18next';
import React, { FC, useMemo } from 'react';
import { IUpcomingDatas } from '../datas';
import styles from './Card.module.less';
import Slider from './Slider';

const Card: FC<IUpcomingDatas> = ({ en, tr, zh, status, progress = 0 }) => {
  const { i18n, t } = useTranslation();

  const text = useMemo(() => {
    if (i18n.language === 'tr') return tr;
    if (i18n.language === 'zh') return zh;
    return en;
  }, [i18n, en, tr, zh]);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.text}>
          <h1>{text?.title}</h1>
          <Paragraph
            ellipsis={{
              rows: 2.5,
              expandable: true,
              symbol: t('common.more'),
            }}
          >
            {text?.content}
          </Paragraph>
          <a href={text.learnMoreUrl} target="_blank" rel="noopener noreferrer">
            <Button type="text">
              {t('common.learn_more')} <ArrowRightOutlined color="#9AA3A7" />
            </Button>
          </a>
        </div>
      </div>
      <Slider percent={progress} type={status} />
    </div>
  );
};

export default Card;
